module.exports = __webpack_public_path__ + "static/media/icon-history-1.a712ba03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-history-1.svg
// module id = 545
// module chunks = 0